import { api } from "../index";

export const subscriptionPlan = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionPlan: builder.query({
      query: (planSlug) => `/api/v1/signup/plan/${planSlug}`,
      transformResponse: (response) =>  {
        if(!response.success) {
          throw new Error("Failed to fetch subscription plan")
        }
        return response?.data
      },
    }),
    
    checkDomainAvailability: builder.query({
      query: (domain) => `/api/v1/signup/domains/${domain}/availability`,
      transformResponse: (response) => {
        return response;
      },
    }),
    
    calculatePrice: builder.mutation({
      query: (data) => ({
        url: "/api/v1/signup/calculate_price",
        method: "POST",
        body: data,
      }),
    }),

    validateCoupon: builder.mutation({
      query: (data) => ({
        url: "/api/v1/coupons/validate",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { 
  useGetSubscriptionPlanQuery, 
  useLazyCheckDomainAvailabilityQuery, 
  useCalculatePriceMutation,
  useValidateCouponMutation
} = subscriptionPlan;
